import React, { useEffect } from "react"

interface IProps {
  ref: React.RefObject<any>
  onClick: () => void
}

export const useOutsideAlerter = ({ ref, onClick }: IProps) => {
  useEffect(() => {
    function handleClickOutside(event: Event) {
      if (ref.current && !ref.current.contains(event.target)) {
        onClick()
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [ref, onClick])
}
